
import {
  BASE_API_URL,
  post,
} from '@/utils/http'

export * from './common'

// 查询特殊申请Card
export const queryOtherApplicationListUrl = `${BASE_API_URL}/ts/queryKsTssqCardList`
export const queryOtherApplicationList = (...args) => {
  return post(queryOtherApplicationListUrl, ...args)
}

// 撤销考生特殊申请
export const cancelOtherApplicationUrl = `${BASE_API_URL}/ts/cancelKsTssq`
export const cancelOtherApplication = (...args) => {
  return post(cancelOtherApplicationUrl, ...args)
}

export const recycleOtherApplcationUrl = `${BASE_API_URL}/ts/refillKsTssq`
export const recycleOtherApplcation = (...args) => {
  return post(recycleOtherApplcationUrl, ...args)
}

// 查询考生特殊申请报名须知
export const queryOtherApplicationNoticeUrl = `${BASE_API_URL}/ts/queryTssqbmxz`
export const queryOtherApplicationNotice = (...args) => {
  return post(queryOtherApplicationNoticeUrl, ...args)
}

// 保存考生特殊申请
export const insertOtherSpecialUrl = `${BASE_API_URL}/ts/insertOrUpdateKsTssq`
export const insertOtherSpecial = (...args) => {
  return post(insertOtherSpecialUrl, ...args)
}

// 我的特殊申请信息
export const querySpecialConfigInfoUrl = `${BASE_API_URL}/ts/queryKsTssq`
export const querySpecialConfigInfo = (...args) => {
  return post(querySpecialConfigInfoUrl, ...args)
}

// 上传附件
export const uploadOtherApplicationAttachmentUrl = `${BASE_API_URL}/ts/uploadAttachment`
export const uploadOtherApplicationAttachment = (...args) => {
  return post(uploadOtherApplicationAttachmentUrl, ...args)
}
